var _classCallCheck = require("/var/lib/jenkins/workspace/deploy-prod-frontend/frontend_src_repo/frontend-v1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/var/lib/jenkins/workspace/deploy-prod-frontend/frontend_src_repo/frontend-v1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/var/lib/jenkins/workspace/deploy-prod-frontend/frontend_src_repo/frontend-v1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/var/lib/jenkins/workspace/deploy-prod-frontend/frontend_src_repo/frontend-v1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/var/lib/jenkins/workspace/deploy-prod-frontend/frontend_src_repo/frontend-v1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _require = require('stream'),
  Readable = _require.Readable;
var StorageStream = /*#__PURE__*/function (_Readable) {
  "use strict";

  _inherits(StorageStream, _Readable);
  function StorageStream(doc, streamEntry) {
    var _this;
    _classCallCheck(this, StorageStream);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(StorageStream).call(this));
    _this._doc = doc;
    _this._streamEntry = streamEntry;
    _this.initialize();
    return _this;
  }
  _createClass(StorageStream, [{
    key: "initialize",
    value: function initialize() {
      this._index = 0;
      this._done = true;
      if (!this._streamEntry) {
        return;
      }
      var doc = this._doc;
      this._bytes = this._streamEntry.size;
      this._allocationTable = doc._SAT;
      this._shortStream = false;
      if (this._bytes < doc._header.shortStreamMax) {
        this._shortStream = true;
        this._allocationTable = doc._SSAT;
      }
      this._secIds = this._allocationTable.getSecIdChain(this._streamEntry.secId);
      this._done = false;
    }
  }, {
    key: "_readSector",
    value: function _readSector(sector) {
      if (this._shortStream) {
        return this._doc._readShortSector(sector);
      } else {
        return this._doc._readSector(sector);
      }
    }
  }, {
    key: "_read",
    value: function _read() {
      var _this2 = this;
      if (this._done) {
        return this.push(null);
      }
      if (this._index >= this._secIds.length) {
        this._done = true;
        return this.push(null);
      }
      return this._readSector(this._secIds[this._index]).then(function (buffer) {
        if (_this2._bytes - buffer.length < 0) {
          buffer = buffer.slice(0, _this2._bytes);
        }
        _this2._bytes -= buffer.length;
        _this2._index++;
        _this2.push(buffer);
      });
    }
  }]);
  return StorageStream;
}(Readable);
module.exports = StorageStream;